var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"dark":"","height":"auto","inset":_vm.footer.inset,"app":""}},[_c('span',{staticClass:"px-3"},[_vm._v("© "+_vm._s(new Date().getFullYear()))])])}
var staticRenderFns = []

export { render, staticRenderFns }